import { h, Component } from 'preact';
// import { sortObjectByOrder, joinClasses, accessNested } from 'utils/utils';
import HTML from 'components/core/html/html.js';
import s from 'components/templates/smallText/smallText.sss';

export default class SmallText extends Component {
	render({ data, isDesktop }) {
		return (
			<HTML
				tag='p'
				markdown
				class={s.text}
			>
				{data.text}
			</HTML>
		);
	}
}
